import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api, msg, pct, money, num, time } from './hubApi';
import { useApp } from './HubContext';
import BuyBox from './BuyBox';

export default function Profile() {
  const { handle } = useParams();
  const { user } = useApp();
  const [p, setP] = useState(null);
  const [f, setF] = useState({ mode: 'PAPER', amount: 10 });
  const [note, setNote] = useState('');
  const load = () => api('/leaders/' + handle).then(setP).catch(e => setNote(msg(e)));
  useEffect(() => { load(); }, [handle]);
  const follow = async () => {
    try { await api('/follow', { method: 'POST', body: { handle, settings: { mode: f.mode, staking: { type: 'MIRROR' } } } }); setNote('You are now mimicking this leader. Manage it under Sources & limits.'); load(); }
    catch (e) { setNote(msg(e)); }
  };
  if (!p) return <p>{note || 'Loading…'}</p>;
  const m = p.metrics, fm = p.followerMetrics;
  return (
    <>
      <section className="card">
        <Link to="/hub/leaderboard" className="fine">← Leaderboard</Link>
        {p.live && <Link to={'/hub/watch/' + p.handle}><button className="sm">● Watch live{p.streamTitle ? ': ' + p.streamTitle : ''}</button></Link>}
        <div className="row between"><h1>{p.displayName}</h1><span className="pill">{p.division.division === 'MORNING' ? 'Morning Locker' : 'Intraday Trader'} · {p.division.lockedDays}/{p.division.totalDays} locked days</span></div>
        <div className="stats">
          <div><b>{m.bets}</b><span>bets · {m.racingDays} days</span></div>
          <div><b className={m.profitUnits >= 0 ? 'pos' : 'neg'}>{m.profitUnits > 0 ? '+' : ''}{num(m.profitUnits, 1)}u</b><span>profit (units)</span></div>
          <div><b>{pct(m.strikeRate)}</b><span>strike rate</span></div>
          <div><b className={m.levelPot >= 0 ? 'pos' : 'neg'}>{pct(m.levelPot)}</b><span>POT (level stakes)</span></div>
          <div><b>{pct(m.pctBank)}</b><span>% of bank</span></div>
          <div><b>{num(m.maxDrawdownUnits, 1)}u</b><span>max drawdown</span></div>
          <div><b>{m.longestLosingRun}</b><span>longest losing run</span></div>
          <div><b>{pct(m.priceEdgeVsBsp)}</b><span>tip price vs BSP</span></div>
        </div>
        {fm.bets > 0 && <p className="fine">Followers’ own results: {fm.bets} bets, POT {pct(fm.pot)}, average price taken {num(fm.avgDecisionPrice)}. Followers usually get a slightly different price from the leader.</p>}
      </section>
      {p.market?.paid && user?.handle !== p.handle && <BuyBox handle={p.handle} market={p.market} user={user} onBought={load} />}
      {user && !p.market?.paid && !p.isFollower && user.handle !== p.handle && (
        <section className="card">
          <h2>Mimic this leader (free)</h2>
          <p className="fine">Their own picks go into your Betfair account in units: each unit they bet is placed as 1 × your unit ({'A$' + (user.unitValue || 10)}). Your limits and kill switch always win. Start on paper to see how it tracks.</p>
          <div className="row">
            <label>Mode<select value={f.mode} onChange={e => setF({ ...f, mode: e.target.value })}>
              <option value="PAPER">Paper</option><option value="ALERT">Alert</option><option value="AUTO">Auto</option></select></label>
            <button onClick={follow}>Start mimicking</button>
          </div>
          {note && <p className="note">{note}</p>}
        </section>)}
      {p.isFollower && !p.market?.paid && <section className="card"><p>You are mimicking this leader. {note}</p></section>}
      <section className="card">
        <h2>Pick history</h2>
        <p className="fine">All picks, including losers, in units so every punter compares on the same scale. Upcoming picks are visible to {p.market?.paid ? 'buyers' : 'followers'} only until the race jumps.</p>
        <div className="scroll"><table>
          <thead><tr><th>Date</th><th>Jump</th><th>Race</th><th>Runner</th><th>Bet</th><th className="r">Units</th><th className="r">Tip price</th><th className="r">BSP</th><th>Result</th></tr></thead>
          <tbody>{p.picks.slice(0, 60).map((x, i) => (
            <tr key={i}><td>{x.raceDate}</td><td>{time(x.startTime)}</td><td>{x.venue} R{x.raceNo}</td><td>{x.runnerNumber}. {x.runnerName}</td><td>{x.side === 'LAY' ? 'Lay ' : ''}{x.betType}</td>
              <td className="r">{x.units != null ? num(x.units, 1) + 'u' : '1u'}</td><td className="r">{num(x.decisionPrice)}</td><td className="r">{num(x.bsp)}</td>
              <td className={x.outcome === 'WON' ? 'pos' : x.outcome === 'LOST' ? 'neg' : ''}>{x.outcome || 'Upcoming'}</td></tr>))}</tbody>
        </table></div>
      </section>
    </>
  );
}
